module.exports = __webpack_public_path__ + "img/user-by-freepik.f689f834.png";